import "../Newsblog.css";
import Card from "react-bootstrap/Card";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import { LinkContainer } from "react-router-bootstrap";
import React, { useState } from "react";
import OfferImg5 from "../../assets/AboutFigure.jpeg";
import offerDescription from "../OfferDescription.jsx";
import {Kachel6} from "../Offer";

export default function YogaNatur() {
  const [matches, setMatches] = useState(window.innerWidth);
  window.addEventListener("resize", checkSize);

  function checkSize() {
    setMatches(window.innerWidth);
  }
  return (
    <>
      <section className="offerSec">
        <h4 className="introHeader">{offerDescription[0].title}</h4>
        <div className="intro">{offerDescription[0].body}</div>
        <h2 id="offer">Angebot</h2>
          <br/>
          <br/>
          <Row lg={2} sm={12} className="g-4">
            <Col>
              <Card className="cardOfferHeight">
                <Card.Body>
                  <Card.Title>{Kachel6.header}</Card.Title>
                  <br></br>
                  <Card.Text>
                    {Kachel6.description}
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            {matches > 768 && (
            <Col>
              <Card.Img className="cardImageDetail" variant="top" src={OfferImg5} />
            </Col>
            )}
          </Row>
        <LinkContainer to={`/`}>
          <Button>Zurück</Button>
        </LinkContainer>
      </section>
    </>
  );
}
